import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_COPY_LINK_ON_UNSIGNED = createFcmConfig('copy_link_on_unsigned', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
